export default __webpack_public_path__ + "static/media/video10-1.c42932c2.webp";